import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";

const EnhanceWidget = () => withHideOnErrorBoundary;

export default EnhanceWidget;
